export class PieMenuItemEvents
{
    static ON_PIE_MENU_POINTER_OVER: string = 'PieMenuItemEvents.ON_PIE_MENU_POINTER_OVER';
    static ON_PIE_MENU_POINTER_OUT: string = 'PieMenuItemEvents.ON_PIE_MENU_POINTER_OUT';
    static ON_PIE_MENU_POINTER_DOWN: string = 'PieMenuItemEvents.ON_PIE_MENU_POINTER_DOWN';
}
